export const filterPlurals: Record<FilterOption, string> = {
  client: 'clients',
  date: 'dates',
  tags: 'tags',
  'proposal-status': 'statuses',
  acceptance: 'statuses',
  validity: 'validity states',
};
